import styled from '@emotion/styled'
import { Props } from '.'

export const Icon = styled.div<Props>(
  ({ icon, color, size }) => `
    height: ${`${size}px`};
    width: ${`${size}px`};
    background-position: center;
    background-size: ${`${size}px`};
    background-repeat: no-repeat;
    background-image: url("${icon}");
    flex-grow: 0;
    background-color: ${color};
`
)
